<template>
    <v-container fluid no-gutters>
        <v-row justify="center" align="center" class="my-0 py-0"
            :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
            <v-col justify="center" align="center" cols=12 lg="6" class="my-0 py-0" style="font-size: 20px;">
                <v-img class="white--text align-end logo" width="500px" contain :src="getImage()" />
                <div class="mt-5" style="font-size: 25px;">{{ data.title }}</div>
                <div>{{ data.type }}</div>
                <div></div>
            </v-col>
            <v-col cols=1 v-if="!$vuetify.breakpoint.mobile">
                <v-divider vertical />
            </v-col>
            <v-col justify="center" align="center" cols=12 lg="5" class="mx-0 px-0">
                <gmap-map :center="center" :zoom="17" :options="options" style="width:100%;  height: 300px;">
                    <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true"
                        @click="center = m.position"></gmap-marker>
                </gmap-map>
                <div class="mt-5">{{ data.address }}</div>
            </v-col>
        </v-row>
        <v-row justify="center" align="center" class="pt-5 mx-0 my-0" :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
            <v-col cols="12" align="start">
                <div v-html="this.data.description">
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import restApi from "@/rest-api"

export default {
    data() {
        return {
            offers: [],
            data: {},
            secret: false,
            partner: false,
            center: { lat: 0, lng: 0 },
            markers: [
                {
                    position: { lat: 0, lng: 0 }
                }
            ],
            options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: true,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUI: false
            },
            contact: {},
            addressUrl: ''
        }
    },
    computed: {
        language() {
            return this.$store.getters.getLanguage.language
        },
    },
    created() {
        this.fetchData(this.$route.path);
        this.getOffers();
        if (this.$store.getters.getCard.card) {
            this.secret = true
        }
    },
    methods: {
        fetchData(path) {
            if (path == "/Team") {
                this.fetchTeam(this.$route.query.id);
            } else {
                this.partner = true;
                this.fetchPartner(this.$route.query.id);
            }
        },
        fetchTeam(id) {
            var search = `/team/${id}`;
            restApi
                .get(search)
                .then(response => {
                    this.data = response.team
                    var coordinates = this.data.coordinates.split(',')
                    this.center.lat = parseFloat(coordinates[0])
                    this.center.lng = parseFloat(coordinates[1])
                    this.markers[0].position.lat = parseFloat(coordinates[0])
                    this.markers[0].position.lng = parseFloat(coordinates[1])
                    this.addressUrl = `https://www.google.gr/maps/search/${this.data.address}+/@+${this.data.coordinates}?hl=en`
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchPartner(id) {
            var search = `/partner/${id}`;
            restApi
                .get(search)
                .then(response => {
                    this.data = response.partner
                    var coordinates = this.data.coordinates.split(',')
                    this.center.lat = parseFloat(coordinates[0])
                    this.center.lng = parseFloat(coordinates[1])
                    this.markers[0].position.lat = parseFloat(coordinates[0])
                    this.markers[0].position.lng = parseFloat(coordinates[1])
                    this.addressUrl = `https://www.google.gr/maps/search/${this.data.address}+/@+${this.data.coordinates}?hl=en`
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getImage() {
            var image = this.data.image
            if (image) {
                return `https://dev.paron-card.gr/uploads/images/${image.imageName}`
            } else {
                return require('@/assets/MEMBERSPARON_LOGO.svg')
            }
        },
        getOffers() {
            var filter = {
                "active": true,
            }
            var search = `/offer/filtered`
            restApi
                .post(search, filter)
                .then(response => {
                    this.offers = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setSecret() {
            this.secret = true;
        }
    }
}
</script>

<style lang="scss" scoped>

@media only screen and (min-width: 600px) {
    .logo {
        width: 30vw;
    }
}

@media only screen and (max-width: 600px) {
    .logo {
        width: 80vw;
    }
}

.theme--light.v-divider {
    border-color: rgb(0 0 0);
}

.v-divider--vertical {
    border-width: 300px thin 100px 0;
}
</style>